import { IAssessmentCreditLot, IExtendedCompany, ILCHttpResponse, ITmpURL } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export const companyApi = createApi({
  reducerPath: 'companyApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/company`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    getExtendedCompany: builder.query<IExtendedCompany, void>({
      query: () => ({
        url: `/extended`,
      }),
      transformResponse: (rawResult: ILCHttpResponse<IExtendedCompany>) => {
        return rawResult.data as IExtendedCompany
      },
    }),
    getAssessmentCreditLots: builder.query<IAssessmentCreditLot[], void>({
      query: () => ({
        url: `/assessment-credit-lots`,
      }),
      transformResponse: (rawResult: ILCHttpResponse<IAssessmentCreditLot[]>) => {
        return rawResult.data ?? []
      },
    }),
    getDirectOrderInvoiceUrl: builder.query<ITmpURL, { lcOrderId: number }>({
      query: ({ lcOrderId }) => ({
        url: `/orders/${lcOrderId}/invoice-url`,
      }),
      transformResponse: (rawResult: ILCHttpResponse<ITmpURL>) => rawResult.data as ITmpURL,
    }),
  }),
})

export const { useLazyGetExtendedCompanyQuery, useGetAssessmentCreditLotsQuery, useLazyGetDirectOrderInvoiceUrlQuery } = companyApi
